import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=86d0f222"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d0f222')) {
      api.createRecord('86d0f222', component.options)
    } else {
      api.reload('86d0f222', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=86d0f222", function () {
      api.rerender('86d0f222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schemes-categories/manage.vue"
export default component.exports